export function cutDecimals(numberString: string, decimals = 2): string {
  const number_ = Number.parseFloat(numberString)

  if (Number.isNaN(number_)) {
    return 'Invalid input'
  }

  const factor = Math.pow(10, decimals)
  return (Math.floor(number_ * factor) / factor).toFixed(decimals)
}
